import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

export function AlertMessage() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        position: 'absolute',
        width: '200px',
        height: '120px',
        backgroundColor: 'white',
        color: 'black',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.3)',
        borderRadius: '8px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    >
      <Typography
        sx={{
          color: 'rgb(0, 0, 0)',
          textAlign: 'center',
          fontSize: '12px',
          fontWeight: 700,
          lineHeight: '18px',
          maxWidth: '132px',
        }}
      >
        {t('alerts:instructionsForQRCodePreview')}
      </Typography>
    </Box>
  );
}
